import React, { useCallback, useEffect, useState } from 'react';
import { Container, Tabs, Tab, Nav, Row, Col } from 'react-bootstrap';
import { Icon, Button, useDimension } from 'lb-components';
import { Api, Toast, useTranslation } from 'lb-store';
import Config from 'lb-store/src/config/config';
import _ from 'lodash';
import * as MenuIcons from '../../../assets/icons/payment';
import * as contentTypes from './types';
import classes from './payment.module.scss';
import {
  UsePayment,
  UseUser,
  UseNavigation,
  UseAlert,
} from 'lb-store/src/hooks';
import UseBottomBar from 'lb-store/src/hooks/useBottomBar';
import { useParams } from 'react-router-dom';
import cx from 'classnames';
import './custom.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Scrollbar } from 'swiper';
import './swiper.scss';
import 'swiper/css';
import 'swiper/css/scrollbar';
import Card from './components/Card/Card';
import {
  BankLogos,
  BankLogosInv,
} from 'lb-components/src/stories/assets/icons/payment';

const types = {
  deposit: {
    title: 'შევსება',
    icon: MenuIcons.Deposit,
    items: [
      {
        key: 'cards',
        title: 'ბარათები',
        icon: MenuIcons.Cards,
        children:
          'საქართველოს ბანკი, თიბისი ბანკი, ლიდერქარდი, ნებისმიერი ბარათი',
      },
      {
        key: 'wallets',
        title: 'ელ.საფულეები',
        icon: MenuIcons.Wallets,
        children: 'თიბისი ფეი',
      },
      {
        key: 'other',
        title: 'სხვა',
        icon: MenuIcons.Other,
        children: 'EPAY.GE, თიბისი ფეი, ოპპა, Liderbet',
      },
    ],
  },
  withdraw: {
    title: 'გატანა',
    icon: MenuIcons.Withdraw,
    items: [
      {
        key: 'cards',
        title: 'ბარათები',
        icon: MenuIcons.Cards,
        children:
          'საქართველოს ბანკი, თიბისი ბანკი, ლიდერქარდი, ნებისმიერი ბარათი',
      },
      {
        key: 'wallets',
        title: 'ელ.საფულეები',
        icon: MenuIcons.Wallets,
        children: 'eMoney, LeaderPay',
      },
      //{
      //  key: 'ids',
      //  title: 'ID ბარათები',
      //  icon: MenuIcons.Ids,
      //  children: 'საქართველოს ბანკი',
      //},
      {
        key: 'cashDesks',
        title: 'სალაროები',
        icon: MenuIcons.CashDesks,
        children: 'სალაროების მისამართები რუკაზე',
      },
    ],
  },
};
const bankColors = {
  BOG: '#FF671B',
  TBC: '#00ABED',
  LIB: '#E70D2F',
  LEADER_CARD: '#f1c157',
};
const bankIds = ['LEADER_CARD', 'BOG', 'TBC', 'ANY'];

const Payment = ({ platform, type = 'deposit', onTypeChange }) => {
  const { User, updateBalance } = UseUser();
  const { lang } = useParams();
  const { push, get, remove, navigate } = UseNavigation();
  const { handleInput } = UseBottomBar();
  const { t } = useTranslation();
  const alert = UseAlert();

  const [activeType, setActiveType] = useState(type);
  const [activeTab, setActiveTab] = useState(
    get('tab') ? get('tab') : platform === 'web' ? 'cards' : null
  );
  const [loader, setLoader] = useState(false);
  const [cards, setCards] = useState([]);
  const payment = UsePayment();


  useEffect(() => {
    if (platform === 'web' && !activeTab) setActiveTab('cards');
  }, [platform]);

  useEffect(() => {
    setActiveType(type);
  }, [type]);

  useEffect(() => {
    payment.getCards(activeType, setLoader).then((response) => {
      setCards(response);
    });
  }, [activeType]);

  const panConverter = (pan) => {
    return _.chunk(pan.split(''), 4).map((v, k) => {
      return k === 0 ? v.splice(0, 1).concat('***') : k === 3 ? v : '****';
    });
  };
  const cardSubmitHandler = async (e, callback) => {
    console.log(e, callback);

    if (activeType === 'deposit') {
      let params = {
        vendor: e.provider.toLowerCase(),
        amount: e.amount,
        cardid: e.cardId,
        loader: e.loader,
      };

      switch (e.provider.toLowerCase()) {
        case 'bog':
          if (e.cardId.toString() === '0') {
            params = { ...params, saveCard: 0, cardid: 'ather' };
          }
          if (e.cardId.toString() === '1') {
            params = { ...params, saveCard: 1, cardid: 'ather' };
          }
          break;
        case 'tbc':
          if (e.cardId.toString() === '0') {
            params = {
              ...params,
              saveCard: 0,
              cardid: 'other',
              vendor: 'visa_tbc',
            };
          } else if (e.cardId.toString() === '1') {
            params = {
              ...params,
              saveCard: 1,
              cardid: 'other',
              vendor: 'visa_tbc',
            };
          } else {
            params = { ...params, vendor: 'visa_tbc' };
          }
          break;
      }

      payment.deposit(params).then((response) => {
        if (response.status) {
          switch (e.provider) {
            case 'TBC':
              payment.frame({
                variant: 'dark',
                outsideDismiss: false,
                callback: frameListener,
                frameListener: 'closePaymentFrame',
                style: {
                  margin: 0,
                  borderRadius: 0,
                  width: platform === 'mob' ? window.innerWidth : '500px',
                  height: '510px',
                },
                onCancel: () => updateBalance(),
                content: {
                  header: (
                    <div className='payment-modal-header'>
                      {activeType === 'deposit'
                        ? t('თანხის შემოტანა')
                        : t('თანხის გატანა')}
                    </div>
                  ),
                  body: (
                    <iframe
                      style={{
                        width: platform === 'mob' ? window.innerWidth : '100%',
                        height:
                          platform === 'mob'
                            ? `calc(${window.innerHeight}px - 1.6rem)`
                            : window.innerHeight > 800
                            ? '600px'
                            : '100%',
                        minHeight:
                          platform === 'mob'
                            ? `calc(${window.innerHeight}px - 1.6rem)`
                            : '510px',
                      }}
                      src={''}
                      name='paymentIframe'
                      id='paymentIframe'
                    >
                      {' '}
                      test
                    </iframe>
                  ),
                },
              });
              setTimeout(() => {
                payment.submitForm(
                  response.data.data.url,
                  response.data.data.trans_id
                );
              }, 100);
              break;
            case 'BOG':
              let url = new URL(response.data.data.url);
              url.searchParams.set(
                'back_url_s',
                `https://www.lider-bet.com/${lang}/payment/status/success`
              );
              url.searchParams.set(
                'back_url_f',
                `https://www.lider-bet.com/${lang}/payment/status/error`
              );
              payment.frame({
                variant: 'dark',
                outsideDismiss: false,
                callback: frameListener,
                frameListener: 'closePaymentFrame',
                size: platform === 'mob' ? 'md' : 'lg',
                closeButton: true,
                fullscreen: platform === 'mob',
                style: {
                  maxWidth: '800px ',
                  height: window.innerHeight > 800 ? '800px' : '700px',
                },
                onCancel: () => updateBalance(),
                content: {
                  body: (
                    <iframe
                      style={{
                        width: platform === 'mob' ? window.innerWidth : '100%',
                        height:
                          platform === 'mob'
                            ? `calc(${window.innerHeight}px - 1.6rem)`
                            : window.innerHeight > 900
                            ? '870px'
                            : '100%',
                        minHeight:
                          platform === 'mob'
                            ? `calc(${window.innerHeight}px - 1.6rem)`
                            : '650px',
                      }}
                      src={url.href}
                      name='paymentIframe'
                      id='paymentIframe'
                    />
                  ),
                  header: (
                    <div className='payment-modal-header'>
                      {activeType === 'deposit'
                        ? t('თანხის შემოტანა')
                        : t('თანხის გატანა')}
                    </div>
                  ),
                },
              });
          }
        } else {
          alert.open({ message: t('დაფიქსირდა შეცდომა') });
        }
      });
    } else {
      //withdraw
      let params = {
        vendor: e.provider.toLowerCase(),
        amount: e.amount,
        cardid: e.cardId,
        sms: e?.sms,
        loader: e.loader,
      };

      if (params.vendor === 'leader_card') {
        const response = await Api.Payments.withdraw({
          /*url: '/api/?app=user/payment/nbsnew&type=check',*/
          url: Config.Payment.withdraw.Nbc.check,
          data: {},
        });
        if (response?.data?.res !== 'yes') {
          Toast.show({
            type: 'error',
            content: t('გადახდის დროს დაფიქსირდა შეცდომა'),
          });
          return;
        }
      }
      //callback({ confirm: true, sms: 'სმს', left: 3 });
      payment.withdraw(params).then((response) => {
        if (response.status) {
          callback({ confirm: false, sms: '', data: { amount: '', sms: '' } });
          updateBalance();
          Toast.show({
            type: 'success',
            content: t('ტრანზაქცია წარმატებით განხორციელდა'),
          });
        } else {
          if (response?.data?.code === 'sms') {
            //სმს უკვე გამოგზავნილია, დაელოდეთ
            if (response?.data?.service_name === 'SB')
              Toast.show({ type: 'error', content: response?.data?.desc });
            else
              callback({
                confirm: true,
                sms: response?.data?.desc,
                left: response?.data?.left,
              });
          } else {
            if (e?.confirm) {
              callback({
                sms: response?.data?.desc,
                left: response?.data?.left,
              });
            } else {
              Toast.show({
                type: 'error',
                content: response?.data?.desc,
              });
            }
          }
        }
      });
    }
  };
  const frameListener = (props) => {
    props.onCancel();
  };

  return (
    <Container
      fluid={'gigantic'}
      className={cx(classes.container, {
        [classes.paymentDark]: false,
      })}
      style={{
        minHeight: platform === 'web' ? '800px' : '100%',
      }}
    >
      <div className={classes.header}>
        {_.map(types, (value, key) => (
          <Button
            key={key}
            onClick={() => {
              if (onTypeChange) onTypeChange(key);
              else setActiveType(key);
              setActiveTab(platform === 'web' ? types[key].items[0].key : null);
            }}
            className={cx({
              [classes[key]]: true,
              [classes.mob]: platform === 'mob',
            })}
            data-active={activeType === key}
            variant={'light'}
          >
            <Icon Icon={value.icon} />
            {t(value.title)}
          </Button>
        ))}
      </div>
      <Tab.Container
        activeKey={activeTab}
        onSelect={(e) => setActiveTab(e)}
        mountOnEnter
        unmountOnExit
      >
        <Row
          style={{
            flexDirection:
              platform === 'web'
                ? null
                : activeTab
                ? 'column'
                : 'column-reverse',
            rowGap: platform === 'web' ? null : '4rem',
          }}
        >
          {(platform === 'web' || !activeTab) && (
            <Col
              xs={platform === 'mob' ? 12 : 2}
              style={
                platform === 'mob'
                  ? {
                      marginBottom: '1.5rem',
                    }
                  : { paddingRight: 0 }
              }
            >
              <Nav variant={'pills'} className={classes.sideNav}>
                {types[activeType].items.map((item, index) => (
                  <Nav.Item key={index} style={{ width: '100%' }}>
                    <Nav.Link
                      as={'span'}
                      style={{
                        padding:
                          platform === 'mob' ? '1.2rem 1.7rem' : '1rem 0.5rem',
                      }}
                      eventKey={item.key}
                      className={cx({
                        [classes.navLink]: true,
                        [classes.mob]: platform === 'mob',
                      })}
                      onClick={() => {
                        if (platform === 'web')
                          push({ key: 'tab', value: item.key });
                      }}
                    >
                      <Icon Icon={item.icon} classname={classes.icon} />
                      <div className={classes.title}>
                        {platform === 'web'
                          ? t(item.title)
                          : t(item.title).toUpperCase()}
                        <span>{t(item.children)}</span>
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
          )}
          <Col
            xs={platform === 'web' ? 10 : 12}
            style={
              platform === 'mob'
                ? {
                    marginTop: '1.8rem',
                    height: '100%',
                  }
                : {
                    paddingLeft: 0,
                    height: '100%',
                  }
            }
          >
            {
                activeType === 'withdraw' && <div className="feeChange" dangerouslySetInnerHTML={{__html: t('feeChange')}}/>
            }


            <Swiper
              slidesPerView={'auto'}
              threshold={10}
              modules={[FreeMode, Scrollbar]}
              freeMode={{ enabled: true, sticky: true, minimumVelocity: 0.05 }}
              scrollbar={{
                draggable: true,
                snapOnRelease: true,
              }}
              className={'swiper-cards'}
            >
              {_.map(cards, (item, index) => {
                return (
                  <SwiperSlide key={`${activeType}-${index}`}>
                    <Card
                      balance={User.balance?.balance}
                      actionType={activeType}
                      id={item.id}
                      platform={platform}
                      provider={item?.bankID}
                      logo={
                        platform === 'web'
                          ? BankLogos[item?.bankID]
                          : BankLogosInv[item?.bankID]
                      }
                      color={bankColors[item?.bankID]}
                      date={item.date}
                      digits={panConverter(item?.pan)}
                      t={t}
                      submit={cardSubmitHandler}
                      /*onMobInput={handleInput}*/
                      onDelete={(data) => {
                        /*let url = `/api/?app=user/payment/remove_card&id=${
                          data?.cardId
                        }&type=${data?.provider === 'BOG' ? 'bog' : 'ufc'}`;*/
                        let url = Config.Payment.remove.replace('{id}', data?.cardId).replace('{type}', data?.provider === 'BOG' ? 'bog' : 'ufc')
                        if (data.action === 'delete') {
                          url = url.concat('&sms_code=', data.sms);
                        }

                        Api.Payments.deleteCard({
                          url: url,
                          loader: setLoader,
                        }).then((response) => {
                          if (data.action === 'sms') {
                            if (response?.data?.code === 'sms') {
                              if (response?.data?.status === 1) {
                                data.callback({
                                  show: true,
                                  confirm: true,
                                  error: {},
                                  data: {},
                                  left: response?.data?.left,
                                });
                              } else {
                                Toast.show({
                                  type: 'error',
                                  content: response?.data?.desc,
                                });
                              }
                            }
                          } else {
                            if (response.status) {
                              setCards([
                                ..._.filter(cards, (v) => v.id !== data.cardId),
                              ]);
                              data.callback({
                                show: false,
                                error: '',
                              });
                            } else {
                              data.callback({
                                show: true,
                                error: response.data.desc,
                              });
                            }
                          }
                        });
                      }}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            {activeTab && (
              <Tab.Content
                className={classes.tabContent}
                style={{ marginTop: platform === 'web' ? '1rem' : '4rem' }}
              >
                {types[activeType].items.map((item, index) => (
                  <Tab.Pane
                    key={index}
                    eventKey={item.key}
                    mountOnEnter
                    unmountOnExit
                  >
                    {React.createElement(contentTypes[item.key], {
                      User: User,
                      platform: platform,
                      actionType: activeType,
                      data: item.key === 'cards' ? cards : [],
                      payment: payment,
                      lang: lang || 'ka',
                      t: t,
                      /*onMobInput: handleInput,*/
                      panConverter: panConverter,
                      onCardSubmit: cardSubmitHandler,
                    })}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            )}
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default Payment;
